import { WalletTransaction } from "@app/core/wallet/domain/model/wallet-transaction";

export class Wallet {
    constructor(
        readonly id: string,
        readonly balance: number,
        readonly transactions: WalletTransaction[],
    ) {}
}